import React from 'react';
import moment from 'moment';
import { IntlShape } from 'react-intl';
import { CostReportItem, getFileExtension } from '../../../../features/cost-report/types';
import styles from './mobile-cost-row.module.scss';
import DownloadButton from '../../../../components/shared/file-download-button';
import CostActionMenu from '../action-menu';

interface MobileCostRowProps {
    item: CostReportItem;
    intl: IntlShape;
    onAddNewCostClick?: (cost: CostReportItem) => void;
    onEditCostClick?: (cost: CostReportItem) => void;
    onDeleteCostClick?: (cost: CostReportItem) => void;
}

const MobileCostRow: React.FC<MobileCostRowProps> = ({
    item,
    intl,
    onAddNewCostClick,
    onEditCostClick,
    onDeleteCostClick
}) => {
    const formattedDate = moment(item.date).format('MM/DD/YYYY');

    return (
        <div className={styles.mobileCardWrapper}>
            <div className={styles.mobileCard}>
                <div className={styles.mobileCardContent}>
                    <div className={styles.mobileCardHeader}>
                        <div className={styles.mobileCardTitle}>
                            <div className={styles.mobileDate}>{formattedDate}</div>
                            {item.projectName && (
                                <div className={styles.mobileProject}>{item.projectName}</div>
                            )}
                        </div>
                    </div>
                    {item.note && (
                        <div className={styles.mobileNote}>
                            {item.note}
                        </div>
                    )}
                    {item.files && item.files.length > 0 && (
                        <div className={styles.mobileFiles}>
                            {item.files.map((file) => {
                                const extension = getFileExtension(file.extension);
                                const fullFileName = `${file.name}${extension ? `.${extension}` : ''}`;
                                return (
                                    <DownloadButton
                                        key={file.id}
                                        fileName={fullFileName}
                                        downloadUrl={file.fileDownloadUrl}
                                        downloadFileName={file.name}
                                    />
                                );
                            })}
                        </div>
                    )}
                </div>
                <div className={styles.mobileAmountSection}>
                    <div className={styles.mobileAmount}>{item.amount}</div>
                    <div className={styles.mobileMenuWrapper}>
                        <CostActionMenu
                            intl={intl}
                            onAddNewCostClick={onAddNewCostClick ? () => onAddNewCostClick(item) : undefined}
                            onEditCostClick={onEditCostClick ? () => onEditCostClick(item) : undefined}
                            onDeleteCostClick={onDeleteCostClick ? () => onDeleteCostClick(item) : undefined}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileCostRow;
